/**
 * Lookup builder — verbatim from v1 (research/03 §12; REQ-ELEM-3). Preserves
 * the `input?_maxdecimals.Maxdecimals` object-read that throws when
 * input?_maxdecimals is undefined (§15.17), the two-arg Math.round, and the
 * `input2_maxvalue` guarded by the `input1_maxvalue` typo.
 */
import { appState } from "../state/app-state";
import { generateStep } from "../common/common-utils";
import { getConditionalDisplay, getToolTipHtml , getElementWidthClass, t , dirAttr } from "./base";

export function buildLookupInput(element: any): string {
  var input1_minvalue =
    element.input1_minvalue != undefined ? element.input1_minvalue : 0;
  var input1_maxvalue =
    element.input1_maxvalue != undefined ? element.input1_maxvalue : 100000;

  let elem1MaxDecimal =
    element.input1_maxdecimals.Maxdecimals != undefined
      ? element.input1_maxdecimals.Maxdecimals
      : 0;
  //input1_minvalue = Math.min(input1_minvalue, elem1MaxDecimal);
  input1_maxvalue = (Math as any).round(input1_maxvalue, elem1MaxDecimal);

  var input1_step =
    element.input1_maxdecimals != undefined
      ? generateStep(element.input1_maxdecimals)
      : 1;
  var input1_isFormula =
    element.input1_isformula != undefined ? element.input1_isformula : false;

  var input2_minvalue =
    element.input2_minvalue != undefined ? element.input2_minvalue : 0;
  var input2_maxvalue =
    element.input1_maxvalue != undefined ? element.input2_maxvalue : 100000;

  let elem2MaxDecimal =
    element.input2_maxdecimals.Maxdecimals != undefined
      ? element.input2_maxdecimals.Maxdecimals
      : 0;
  //input2_minvalue = Math.min(input2_minvalue, elem2MaxDecimal);
  input2_maxvalue = (Math as any).round(input2_maxvalue, elem2MaxDecimal);

  var input2_step =
    element.input2_maxdecimals != undefined
      ? generateStep(element.input2_maxdecimals)
      : 1;
  var input2_isFormula =
    element.input2_isformula != undefined ? element.input2_isformula : false;

  var conditionalDisplay = getConditionalDisplay(element);
  var elementCreated = "";
  var classInput1 = input1_isFormula ? "hide-element" : "";
  var classInput2 = input2_isFormula ? "hide-element" : "";
  let classInput1Element = input1_isFormula
    ? "lookup-element-with-formula"
    : "";
  let classInput2Element = input2_isFormula
    ? "lookup-element-with-formula"
    : "";

  let toolTipHtml = getToolTipHtml(element, "span");

  // Issue #126 / #110: stamp whether each axis label should be shown as a
  // customer-visible Shopify order line item property. A label that starts
  // with "_" is already intentionally hidden (Shopify convention) — treat it
  // as internal-only and suppress the visible cart entry. A label that does
  // NOT start with "_" is a merchant-configured display name (e.g.
  // "WIDTH, mm (3000 Max)") and MUST appear in the order so the merchant can
  // fulfil it. This single attribute lets the ATC submitters in
  // submit-form-data.ts gate the visible vs hidden-only injection without
  // needing to re-inspect the label string at submit time.
  const input1ShowInOrder: boolean = !String(element.input1_label).startsWith("_");
  const input2ShowInOrder: boolean = !String(element.input2_label).startsWith("_");

  elementCreated +=
    "<div class='element" + getElementWidthClass(element) + " " +
    classInput1 +
    "' data-element='" +
    element.Identifier +
    "_1' " +
    conditionalDisplay.conditionalTemplate +
    "><label style='color:" +
    appState.calculatorStyling.upperTextColor +
    "'" + dirAttr(element.input1_label) + ">" +
    t(element.input1_label) +
    toolTipHtml +
    "</label><input onfocusout='ChangeEvent(null)' data-lookup='true' data-lookupelementindex='1' data-identifier='" +
    element.Identifier +
    "' class='calc-prop " +
    classInput1Element +
    "' step='" +
    input1_step +
    "' data-minvalue='" +
    input1_minvalue +
    "' min='" +
    input1_minvalue +
    "' max='" +
    input1_maxvalue +
    "' onblur='validity.valid || (value = \"\");' data-calcname='" +
    element.input1_label +
    "' data-lookup-show-in-order='" +
    input1ShowInOrder +
    "' data-isformula='" +
    input1_isFormula +
    "' data-formula='" +
    element.input1_formula +
    "' name=\"properties[" +
    element.input1_label +
    "]\" value='" +
    element.input1_minvalue +
    "' type='number'/></div>";
  elementCreated +=
    "<div class='element" + getElementWidthClass(element) + " " +
    classInput2 +
    "' data-element='" +
    element.Identifier +
    "_2' " +
    conditionalDisplay.conditionalTemplate +
    "><label style='color:" +
    appState.calculatorStyling.upperTextColor +
    "'" + dirAttr(element.input2_label) + ">" +
    t(element.input2_label) +
    toolTipHtml +
    "</label><input onfocusout='ChangeEvent(null)' data-lookup='true' data-lookupelementindex='2' data-identifier='" +
    element.Identifier +
    "' class='calc-prop " +
    classInput2Element +
    "' step='" +
    input2_step +
    "' data-minvalue='" +
    input2_minvalue +
    "' min='" +
    input2_minvalue +
    "' max='" +
    input2_maxvalue +
    "' onblur='validity.valid || (value = \"\");' data-calcname='" +
    element.input2_label +
    "' data-lookup-show-in-order='" +
    input2ShowInOrder +
    "' data-isformula='" +
    input2_isFormula +
    "' data-formula='" +
    element.input2_formula +
    "' name=\"properties[" +
    element.input2_label +
    "]\" value='" +
    element.input2_minvalue +
    "' type='number'/></div>";

  return elementCreated;
}
